import React from 'react'
import { Monitor, Moon, Sun1 } from 'iconsax-react'
import styled from 'styled-components'

import { THEMES, useTheme } from 'components/context/ThemeContext'

const ICON_SIZE = 18

const Wrapper = styled.div`
  padding: 8px 12px 10px;
`

const Label = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`

const SegmentRow = styled.div`
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--color-border, #e5e5e5);
  background: var(--color-surface, #f5f5f5);
`

const Segment = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: none;
  background: ${(props) => (props.$selected ? 'var(--primary)' : 'transparent')};
  color: ${(props) => (props.$selected ? 'var(--button-primary-text-default)' : 'var(--primary-color)')};
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:not(:last-child) {
    border-right: 1px solid var(--color-border, #e5e5e5);
  }

  &:hover {
    background: ${(props) =>
      props.$selected ? 'var(--primary)' : 'var(--dropdown-hover, rgba(0,0,0,0.06))'};
  }

  &:focus {
    outline: 2px solid var(--primary);
    outline-offset: -2px;
  }
`

const Divider = styled.div`
  border-bottom: 1px solid var(--color-border, #eee);
  margin: 0 4px;
`

const segments = [
  { value: THEMES.LIGHT, label: 'Light', Icon: Sun1 },
  { value: THEMES.DARK, label: 'Dark', Icon: Moon },
  { value: THEMES.SYSTEM, label: 'System', Icon: Monitor },
]

export function ThemeSegmentedSelector() {
  const { theme, setTheme } = useTheme()

  return (
    <>
      <Wrapper>
        <Label>Theme (BETA)</Label>
        <SegmentRow role="group" aria-label="Theme">
          {segments.map(({ value, label, Icon }) => (
            <Segment
              key={value}
              type="button"
              $selected={theme === value}
              onClick={() => setTheme(value)}
              aria-label={label}
              aria-pressed={theme === value}
              title={label}
            >
              <Icon size={ICON_SIZE} />
            </Segment>
          ))}
        </SegmentRow>
      </Wrapper>
      <Divider />
    </>
  )
}

export default ThemeSegmentedSelector
